<div class="container">
  <ng-content></ng-content>
</div>

